import { ProductDetailDto, ProductDto, ProductEditDto } from './product';
import {
  ProductParameterDetailDto,
  ProductParameterEditDto
} from './productParameter';
import { ProductProductDto, ProductProductEditDto } from './productProduct';

export const mapProductDetailToEdit = (
  dto: ProductDetailDto
): ProductEditDto => ({
  id: dto.id,
  runNo: dto.runNo,
  lotNo: dto.lotNo,
  toNorlab: dto.toNorlab,
  norlabNo: dto.norlabNo,
  runDate: dto.runDate,
  lotDate: dto.lotDate,
  norlabDate: dto.norlabDate,
  archive: dto.archive,
  description: dto.description,
  producedDate: dto.producedDate,
  producedAmount: dto.producedAmount,
  totalAmount: dto.totalAmount,
  runText: dto.runText,
  lotText: dto.lotText,
  qaStation: dto.qaStation,
  numberOfPallets: dto.numberOfPallets,
  runSystemId: dto.runSystemId,
  gradeId: dto.gradeId,
  packagingId: dto.packagingId,
  palletId: dto.palletId,
  specificationId: dto.specificationId,
  productStatusId: dto.productStatusId
});

export const mapProductParameterToEdit = (
  product: ProductDetailDto,
  parameter: ProductParameterDetailDto
): ProductParameterEditDto => ({
  id: parameter.id,
  productId: product.id,
  parameterId: parameter.parameterId,
  methodId: parameter.methodId,
  instrumentId: parameter.instrumentId,
  measuredValue: parameter.measuredValue,
  userId: parameter.userId
});

export const mapProductDetailToProduct = (
  dto: ProductDetailDto
): ProductDto => ({
  id: dto.id,
  runNo: dto.runNo,
  lotNo: dto.lotNo,
  toNorlab: dto.toNorlab,
  norlabNo: dto.norlabNo,
  runDate: dto.runDate,
  lotDate: dto.lotDate,
  norlabDate: dto.norlabDate,
  archive: dto.archive,
  description: dto.description,
  producedDate: dto.producedDate,
  producedAmount: dto.producedAmount,
  totalAmount: dto.totalAmount,
  runText: dto.runText,
  lotText: dto.lotText,
  qaStation: dto.qaStation,
  numberOfPallets: dto.numberOfPallets,
  runSystemId: dto.runSystemId,
  gradeId: dto.gradeId,
  packagingId: dto.packagingId,
  palletId: dto.palletId,
  specificationId: dto.specificationId,
  productStatusId: dto.productStatusId,
  runSystemNo: dto.runSystem?.no,
  runSystemName: dto.runSystem?.name,
  gradeName: dto.grade?.name,
  productTypeName: dto.productType?.name,
  segmentName: dto.segment?.name,
  productStatusName: dto.productStatus?.name,
  specificationNo: dto.specification?.no,
  specificationName: dto.specification?.name,
  userId: dto.userId,
  lastUpdated: dto.lastUpdated
});

export const mapProductProductToEdit = (
  product: ProductDetailDto,
  productProduct: ProductProductDto
): ProductProductEditDto => ({
  id: productProduct.id,
  product1Id: product.id,
  product2Id: productProduct.product2Id,
  amount: productProduct.amount
});
